import { render, staticRenderFns } from "./ImagesSelect.vue?vue&type=template&id=f5128642&scoped=true&lang=pug"
import script from "./ImagesSelect.vue?vue&type=script&lang=js"
export * from "./ImagesSelect.vue?vue&type=script&lang=js"
import style0 from "./ImagesSelect.vue?vue&type=style&index=0&id=f5128642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5128642",
  null
  
)

export default component.exports